import { useCallback } from 'react';

/**
 * @returns a callback to copy the text if the text is truthy
 * 	otherwise returns undefined
 */
export const useCopyToClipboard = (text: string | undefined | null): VoidFunction | undefined => {
	const callback = useCallback(() => {
		if (text) {
			navigator.clipboard.writeText(text);
		}
	}, [text]);
	if (text) {
		return callback;
	}
};
